import React, { Component, createRef } from 'react';

import { number, string } from 'prop-types';

import { RecaptchaAPI, RecaptchaSize } from '@philips-emr/tws-components-api';
import { Theme } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { eventListener, oneOf } from '@philips-emr/tws-core/lib/component/prop-types';
import { enumValues, isFunction, loadScript } from '@philips-emr/tws-utils';

@AwesomeComponent({ type: ComponentType.DATA_ENTRY, api: RecaptchaAPI })
class Recaptcha extends Component {
  constructor(props) {
    super(props);
    this.captchaRef = createRef();
  }

  state = {
    id: string,
  };

  static propTypes = {
    siteKey: string,
    theme: oneOf(enumValues(Theme)),
    size: oneOf(enumValues(RecaptchaSize)),
    type: string,
    tabIndex: number,
    onChange: eventListener,
    value: string,
  };

  static defaultProps = {
    siteKey: '',
    theme: Theme.LIGHT,
    size: RecaptchaSize.NORMAL,
    type: 'image',
    tabIndex: 0,
  };

  onLoadCallback = () => {
    const { onChange, value: oldValue } = this.props;
    const { id } = this.state;
    const response = window.grecaptcha.getResponse(id);

    this.setState({
      response,
    });

    isFunction(onChange) && onChange({ value: response, oldValue });
  };

  onExpireCallback = () => {
    window.grecaptcha.reset();

    const { onChange, value: oldValue } = this.props;
    const response = '';

    this.setState({
      response,
    });

    isFunction(onChange) && onChange({ value: response, oldValue });
  };

  renderGrecaptcha = () => {
    if (window.grecaptcha && this.captchaRef) {
      const { siteKey,  theme, size, tabIndex, type } = this.props;

      const id = window.grecaptcha.render(this.captchaRef.current, {
        'sitekey' : siteKey,
        'theme': theme,
        'size': size,
        'type': type,
        'tabindex': tabIndex,
        'callback': () => this.onLoadCallback(),
        'expired-callback': () => this.onExpireCallback(),
      });

      this.setState({
        id,
      });

    }
  };

  componentDidMount() {
    const onLoadFunctionName = 'twsrecaptcha';

    const src = `https://www.google.com/recaptcha/api.js?onload=${onLoadFunctionName}&render=explicit`;
    loadScript(src, true, true, 'twsRecaptchaID');
    setTimeout(this.renderGrecaptcha, 1000);
  }

  render(){
    const { siteKey } = this.props;

    return(
      <div className="c-captcha g-recaptcha" data-sitekey={siteKey} ref={this.captchaRef} />
    );
  }
}

export default Recaptcha;
